export default __webpack_public_path__ + "static/media/Bb5.da3271cc.mp3";